import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useCallbackRef } from './useCallbackRef';
function useControllableState(_ref) {
  var prop = _ref.prop,
    defaultProp = _ref.defaultProp,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  var _useUncontrolledState = useUncontrolledState({
      defaultProp: defaultProp,
      onChange: onChange
    }),
    _useUncontrolledState2 = _slicedToArray(_useUncontrolledState, 2),
    uncontrolledProp = _useUncontrolledState2[0],
    setUncontrolledProp = _useUncontrolledState2[1];
  var isControlled = prop !== undefined;
  var value = isControlled ? prop : uncontrolledProp;
  var handleChange = useCallbackRef(onChange);
  var setValue = React.useCallback(function (nextValue) {
    if (isControlled) {
      var setter = nextValue;
      var _value = typeof nextValue === 'function' ? setter(prop) : nextValue;
      if (_value !== prop) {
        handleChange(_value);
      }
    } else {
      setUncontrolledProp(nextValue);
    }
  }, [isControlled, prop, setUncontrolledProp, handleChange]);
  return [value, setValue];
}
function useUncontrolledState(_ref2) {
  var defaultProp = _ref2.defaultProp,
    onChange = _ref2.onChange;
  var uncontrolledState = React.useState(defaultProp);
  var _uncontrolledState = _slicedToArray(uncontrolledState, 1),
    value = _uncontrolledState[0];
  var prevValueRef = React.useRef(value);
  var handleChange = useCallbackRef(onChange);
  React.useEffect(function () {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}
export { useControllableState };